import { cssColorValue } from '@spotify-internal/encore-web/core';
import styled, { css } from 'styled-components';
export const VideoPlayerContainer = styled.div `
  display: flex;
  background-size: ${({ backgroundImage }) => backgroundImage ? 'contain' : 'unset'};
  background-image: ${({ backgroundImage }) => backgroundImage ? `url(${backgroundImage})` : 'none'};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  border: none;
  padding: 0;
  cursor: pointer;
  :focus-visible {
    outline: 3px solid ${cssColorValue('textBase')};
    outline-offset: 2px;
  }
  flex-direction: column;
  position: relative;
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  overflow: hidden;
  .buttons {
    z-index: 200;
    overflow: hidden;
    padding-top: 8px;
    padding-bottom: 8px;
    top: ${({ aspectRatio }) => (aspectRatio === '9 / 16' ? '0' : 'unset')};
    bottom: ${({ aspectRatio }) => (aspectRatio === '9 / 16' ? 'unset' : '0')};
    opacity: 0;
    transition: all 0.3s cubic-bezier(0.54, 0, 0.5, 1);
  }
  ${({ showFullControls }) => showFullControls &&
    css `
      .buttons {
        opacity: 1;
        padding-top: 12px;
        padding-bottom: 12px;
      }
    `}
  .loading-overlay {
    opacity: 0%;
  }
  ${({ isLoading, showDisabledOverlay }) => isLoading &&
    !showDisabledOverlay &&
    css `
      .loading-overlay {
        opacity: 60%;
      }
    `}
  :after {
    content: ' ';
    position: absolute;
    background: black;
    opacity: 0%;
    height: 100%;
    width: 100%;
    transform: translateZ(100px);
    transition: all 0.5s cubic-bezier(0.75, 0, 0, 1);
  }
  ${({ showDisabledOverlay }) => showDisabledOverlay &&
    css `
      :after {
        opacity: 60%;
      }
    `}
  .overlay {
    opacity: 0%;
    transition: all 0.5s cubic-bezier(0.75, 0, 0, 1);
  }
  ${({ showBlurbAndMetadata }) => showBlurbAndMetadata &&
    css `
      .overlay {
        opacity: 100%;
      }
    `}

  > mux-video {
    width: 100%;
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
  }
`;
export const ControlsAndOverlay = styled.div `
  display: flex;
  flex-direction: column;
  text-align: start;
  position: relative;
  height: 100%;
  width: 100%;
`;
export const LoadingOverlay = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  height: 100%;
  width: 100%;
`;
//# sourceMappingURL=ui.js.map